import * as React from "react";

import {
  Input,
  makeStyles,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import clsx from "clsx";

import CallAgapeTooltip from "../editable/components/CallAgapeTooltip";

const useStyle = makeStyles((theme) => ({
  root: (props) => ({
    flip: false,
    boxShadow: "0 1px 3px rgba(50,50,93,.15), 0 1px 0 rgba(0,0,0,.02)",
    border: "solid 1px #f8f9fe",
    borderRadius: "6px",
    transition: "box-shadow .15s ease",
    minWidth: props.fullWidth && "100% !important",
    "& .MuiInput-underline":{
      "&::after, &::before": {
        borderBottom: props.noUnderline ?  "none" : ""
      }
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
    borderBottom:  props.noUnderline ?  "none" : ""
    },
    "&::placeholder": {
      color: "red",
    },
    "& .MuiInputBase-root": {
      backgroundColor: "unset"
    },
  }),
  focused: {
    boxShadow: "0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08)",
  },
  legend: (props) => ({
    fontSize: "1.272rem",
    fontWeight: "bold",
    fontFamily: "Vazir-Bold !important",
    color: "black",
    "&:after": {
      content: props.editable ? "" : '"*"',
      color: theme.palette.error.main,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: props.bigLegend ?  "14px !important" : "",
      fontWeight:  props.bigLegend ?  "bold" : '',
      fontFamily:  props.bigLegend ?  "Vazir-Bold !important" : '',
      margin:  props.bigLegend ?  "10px 0" : ''
    },
  }),
  errorText: {
    fontSize: "1rem",
    color: "red",
  },
  error: {
    color: "red",
    borderColor: "red",
  },
}));
const AgapeTextField = ({
  email,
  legend,
  multipleSelect,
  editable = true,
  classNameCustomLegend,
  classNameCustom,
  error,
  tooltip,
  tooltipText = "زمان تقریبی که برای مشارکت داوطلبانه و نیکوکارانه در نظر گرفته اید",
  tooltipIconColor = "rgb(93 91 91)",
  tooltipTextColor = "black",
  placeholder = "",
  cwc,
  fullWidth,
  noUnderline,
  bigLegend,
  ...props
}) => {
  const classes = useStyle({ props, editable, fullWidth, noUnderline, bigLegend });
  const [focus, setFocus] = React.useState(false);
  const handleTextFieldOnFocus = () => {
    setFocus(true);
  };
  const handleTextFieldOnBlur = () => {
    setFocus(false);
  };

  return (
    <>
      <div style={{ display: "flex" }}>
        {legend ? (
          <Typography
            className={clsx(
              classes.legend,
              classNameCustomLegend && classNameCustomLegend
            )}
          >
            {legend}
            &nbsp;
            <span className={classes.errorText}>
              {error ? `  ${error}` : ""}
            </span>
          </Typography>
        ) : null}
        {tooltip ? (
          <CallAgapeTooltip
            IsOptionalText={tooltipText}
            iconColor={tooltipIconColor}
            tooltipTextColor={tooltipTextColor}
          />
        ) : null}
      </div>
      {multipleSelect ? (
        <Select
          labelId="demo-mutiple-name-label"
          id="demo-mutiple-name"
          multiple
          placeholder={placeholder}
          input={
            // eslint-disable-next-line react/jsx-wrap-multilines
            <Input
              placeholder={placeholder}
              disableUnderline
              className={clsx(
                classes.root,
                focus && classes.focused,
                classNameCustom && classNameCustom
              )}
            />
          }
          {...props}
        />
      ) : (
        <TextField
          {...props}
          dir={email ? "ltr" : "rtl"}
          onFocus={props.onFocus || handleTextFieldOnFocus}
          onBlur={props.onBlur || handleTextFieldOnBlur}
          placeholder={placeholder}
          className={clsx(
            classes.root,
            focus && classes.focused,
            classNameCustom && classNameCustom,
            error ? `  ${classes.error}` : ""
          )}
        />
      )}
    </>
  );
};

export default AgapeTextField;
